import { initialTableShow } from 'utils/settings';

// API URLs
export const EDGES_LIST_URL = '/networks/edges/list';
export const EDGES_FILTERS_URL = '/networks/edges/filters';
export const EDGE_DETAIL_URL = '/networks/edges';
export const EDGE_RESTART_SUFFIX = '/restart';
export const EDGE_DEPLOY_SUFFIX = '/deploy';
export const EDGE_NETWORKS_SUFFIX = '/networks';

// Pagination
export const DEFAULT_PAGE_SIZE = 100;

// Interfaces
export interface EdgeListItem {
  edge_id: string;
  data_residency: string;
  region_name: string;
  edge_version: string;
  network_count: number;
  edge_ip: string;
  status: string;
  machine_type: string;
  machine_size: string;
  region_provider: string;
}

export interface Pagination {
  page: number;
  page_size: number;
  total_items: number;
  total_pages: number;
  has_next: boolean;
  has_previous: boolean;
}

export interface QueryMetadata {
  failed_drs: string[];
  queried_drs: string[];
  is_complete: boolean;
  warnings: string[];
}

export interface EdgeListResponse {
  data: EdgeListItem[];
  pagination: Pagination;
  query_metadata?: QueryMetadata;
}

export interface EdgeFiltersResponse {
  data_residencies: string[];
  region_names: string[];
  region_providers: string[];
  machine_types: string[];
  machine_sizes: string[];
  edge_versions: string[];
  statuses: string[];
}

export interface EdgeDetailResponse {
  edge_id: string;
  edge_ip: string;
  data_residency: string;
  region_name: string;
  region_provider: string;
  machine_type: string;
  machine_size: string;
  edge_version: string;
  network_count: number;
  status: string;
  created_at: string;
  last_updated: string;
  last_health_check: string;
  cpu_cores: number;
  memory_gb: number;
  uptime_seconds: number;
  metadata: Record<string, string>;
  grafana_url?: string;
  datadog_url?: string;
}

export interface EdgeActionResponse {
  body?: {
    datadog_url?: string;
  };
}

export interface EdgeNetworkItem {
  data_residency: string;
  network_id: string;
  customer_id: string;
  customer_name: string;
  role: string;
  network_name: string;
}

export interface EdgeNetworksResponse {
  data: EdgeNetworkItem[];
  pagination: Pagination;
  query_metadata?: QueryMetadata;
}

// Sortable fields (must match API-accepted sort_by values)
export const SORTABLE_FIELDS: Record<string, string> = {
  edge_id: 'edge_id',
  region_name: 'region_name',
  data_residency: 'data_residency',
  status: 'status',
  network_count: 'network_count'
};

// Default filter state
export interface EdgeFilters {
  search: string;
  data_residency: string;
  region_name: string;
  region_provider: string;
  machine_type: string;
  machine_size: string;
  edge_version: string;
  status: string;
}

export const defaultNavigation = {
  fieldName: 'edge_id',
  direction: initialTableShow.direction,
  currentPage: initialTableShow.currentPage,
  itemsPerPage: DEFAULT_PAGE_SIZE
};

export const defaultFilters: EdgeFilters & typeof defaultNavigation = {
  search: '',
  data_residency: '',
  region_name: '',
  region_provider: '',
  machine_type: '',
  machine_size: '',
  edge_version: '',
  status: '',
  ...defaultNavigation
};
